import { useMemo } from 'react';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { extrairYyyyMm, MESES } from '@/shared/utils/datas';
import { formatarMoeda } from '@/shared/utils/numeros';
import { SimuladorFolhaPorMes } from '../simulador-folha.types';

const CHART_HEIGHT = 320;

function labelMesCurto(competencia: string): string {
  const yyyymm = extrairYyyyMm(competencia);
  const mes = Number(yyyymm.split('-')[1]);
  return MESES[mes - 1]?.slice(0, 3) ?? yyyymm;
}

interface Props {
  dados: SimuladorFolhaPorMes[];
}

export function GraficoPorMes({ dados }: Props) {
  const chartData = useMemo(
    () =>
      dados.map((item) => ({
        mes: labelMesCurto(item.competencia),
        atual: item.totalAtual,
        projetado: item.totalProjetado,
      })),
    [dados],
  );

  if (!dados.length) {
    return null;
  }

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="card-title mb-3">Folha por mês</h6>
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
          <LineChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mes" tick={{ fontSize: 11 }} />
            <YAxis
              tickFormatter={(valor) => formatarMoeda(Number(valor))}
              width={100}
              tick={{ fontSize: 10 }}
            />
            <Tooltip
              formatter={(valor) => formatarMoeda(Number(valor ?? 0))}
              labelFormatter={(label) => `Mês: ${label}`}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="atual"
              name="Atual"
              stroke="#6c757d"
              strokeWidth={2}
              dot={{ r: 3 }}
            />
            <Line
              type="monotone"
              dataKey="projetado"
              name="Projetado"
              stroke="#0d6efd"
              strokeWidth={2}
              dot={{ r: 3 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
